import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';
import { screenReaderOnlyStyles } from './invisible-table.style';

// Note: Headings should be visible and accessible to all users. This is our pattern and is best practice.
// Only use an invisible heading to preserve a11y in rare cases where the design won't allow a heading.

export const InvisibleHeading = styled(Text)`
  ${screenReaderOnlyStyles}
`;
